/**
 * Settings → Account panel.
 *
 * Read-only view of the signed-in user: display name, UPN, OID, tenant
 * id, and the app roles claimed by their JWT. No actions yet.
 */
import { Badge, Group, Stack, Text } from "@mantine/core";
import type { WhoAmI } from "../../api/types";

export function AccountPanel({ user }: { user: WhoAmI | undefined }) {
  if (!user) {
    return <Text size="sm" c="dimmed">Loading account…</Text>;
  }
  return (
    <Stack gap="lg">
      <Field label="Name" value={user.name ?? "—"} />
      <Field label="Email / UPN" value={<code>{user.preferred_username ?? "—"}</code>} />
      <Field label="Object ID" value={<code>{user.oid}</code>} mono />
      <Field label="Tenant ID" value={<code>{user.tid ?? "—"}</code>} mono />
      <Field
        label="App roles"
        value={
          user.roles.length === 0 ? (
            <Text size="sm" c="dimmed">none</Text>
          ) : (
            <Group gap={6} wrap="wrap">
              {user.roles.map((r) => (
                <Badge key={r} variant="light" color="accent">{r}</Badge>
              ))}
            </Group>
          )
        }
      />
    </Stack>
  );
}

function Field({
  label,
  value,
  mono = false,
}: {
  label: string;
  value: React.ReactNode;
  mono?: boolean;
}) {
  return (
    <Group justify="space-between" align="flex-start" wrap="nowrap" className="kse-settings-row">
      <Text size="sm" c="dimmed" miw={140}>{label}</Text>
      <div style={mono ? { fontFamily: "var(--font-mono)" } : undefined}>{value}</div>
    </Group>
  );
}
